import { type ReactNode } from 'react';
import { useAuthStore } from '../../store/auth.store';
import { TENANT_NAV } from '../../lib/nav-config';
import { AppShell } from './AppShell';

/**
 * Envoltório das rotas /faq e /faq/:slug — preserva a sidebar do tenant
 * quando o usuário está logado, e renderiza a página em um container
 * centralizado quando é visitante público (sem sessão).
 *
 * O brief original deixou /faq fora do TenantLayout porque a FAQ é
 * semi-pública (mesma URL serve quem está deslogado). Usuário logado
 * clicando em "Base de conhecimento" via sidebar esperava continuar
 * dentro do shell — esse wrapper resolve sem duplicar a rota.
 *
 * As páginas Faq.tsx e FaqArtigo.tsx ficam SEM container externo —
 * o shell provê `p-6` no `<main>` e o ramo público adiciona aqui o
 * `max-w-4xl mx-auto` pra evitar texto colado nas bordas.
 */
export function FaqShellAware({ children }: { children: ReactNode }): JSX.Element {
  const usuario = useAuthStore((s) => s.usuario);
  if (usuario) {
    return <AppShell nav={TENANT_NAV}>{children}</AppShell>;
  }
  return (
    <div className="min-h-screen bg-bg-app">
      <div className="mx-auto max-w-4xl px-6 py-10">{children}</div>
    </div>
  );
}
